/**
 * @file   src\reducers\userprofile.js
 * @brief  This file is responsible for user profile reducer
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { createSlice } from "@reduxjs/toolkit";
import { fetchUserDetails, fetchUserPrivileges, fetchUserStatistics, getNotificationSettings } from "../actions/userprofile";
const initialState = {
  loading: false,
  userDetails: {},
  error: "",
  // True, not false: the fetch is dispatched from a mount effect, so a false
  // initial value leaves one render where Notifications.js's toggles are
  // enabled and showing defaults - a click there would save the wrong value.
  notificationLoading : true,
  notificationSettings : {},
  notificationError : "",
  userPrivilegesLoading : false,
  userPrivileges : {},
  userPrivilegesError : "",
  userStaticticsLoading : false,
  userStatictics : {},
  userStaticticsError : "",
  userPlan : "",
};

const userProfile = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUserPlan: (state, payload) => {
      state.userPlan = payload.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserDetails.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(fetchUserDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.userDetails = action.payload.result;
          state.error = "";        
      });
    
    builder.addCase(fetchUserDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(getNotificationSettings.pending, (state, action) => {
      state.notificationLoading = true;
      state.notificationError = "";
    });

    builder.addCase(getNotificationSettings.fulfilled, (state, action) => {
      state.notificationLoading = false;
      state.notificationSettings = action.payload.result;
      state.notificationError = "";
    });

    builder.addCase(getNotificationSettings.rejected, (state, action) => {
      state.notificationLoading = false;
      state.notificationError = action?.error?.message;
    });

    builder.addCase(fetchUserPrivileges.pending, (state, action) => {
      state.userPrivilegesLoading = true;
      state.userPrivilegesError = "";
    });

    builder.addCase(fetchUserPrivileges.fulfilled, (state, action) => {
      state.userPrivilegesLoading = false;
      state.userPrivileges = action.payload.result;
      state.userPrivilegesError = "";
    });

    builder.addCase(fetchUserPrivileges.rejected, (state, action) => {
      state.userPrivilegesLoading = false;
      state.userPrivilegesError = action?.error?.message;
    });

    builder.addCase(fetchUserStatistics.pending, (state, action) => {
      state.userStaticticsLoading = true;
      state.userStaticticsError = "";
    });

    builder.addCase(fetchUserStatistics.fulfilled, (state, action) => {
      state.userStaticticsLoading = false;
      state.userStatictics = action.payload.result;
      state.userStaticticsError = "";
    });

    builder.addCase(fetchUserStatistics.rejected, (state, action) => {
      state.userStaticticsLoading = false;
      state.userStaticticsError = action?.error?.message;
    });
  },
  
});
// Action creators are generated for each case reducer function
export const { setUserPlan } = userProfile.actions

export default userProfile.reducer;
